// extracted by mini-css-extract-plugin
export default {"root":"ApiTesterApp_root__-StQP","apiNavLinks":"ApiTesterApp_apiNavLinks__UFDjd","albumsList":"ApiTesterApp_albumsList__P44ES"};